var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExpand = function SvgIconExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.75a.75.75 0 0 1 .75.746l.01 1.934 2.46-2.46a.75.75 0 1 1 1.06 1.06L5.561 13.5H7.5a.75.75 0 1 1 0 1.5l-3.732-.002a.75.75 0 0 1-.75-.746L3 10.503a.75.75 0 0 1 .746-.754ZM10.503 3l3.748.02a.75.75 0 0 1 .746.748L15 7.5a.75.75 0 0 1-1.5.002l-.002-1.94-2.468 2.469a.748.748 0 0 1-1.06 0 .75.75 0 0 1 0-1.061l2.46-2.46-1.933-.01A.75.75 0 0 1 10.5 3h.003Z",
    id: "icon-expand_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 38,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FA5851",
    xlinkHref: "#icon-expand_svg__a",
    transform: "translate(10 10)"
  }))));
};
export default SvgIconExpand;